/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import {Parser} from "acorn";
import {Toast} from "react-bootstrap";
import './index.scss';
import { withRouter } from 'react-router-dom';
import NameBlock from "./Steps/NameBlock";
import DefineArguments from "./Steps/DefineArguments";
import AssignScript from "./Steps/AssignScript";
import {blockToXmlSanitized, addTenantToPayload} from "../../utils";
import BaseSaveModal from "./BaseSaveModal";

export class CreateJSBlock extends BaseSaveModal {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            toastVisible: false
        };
        this._handleDefineArgumentsNext = this._handleDefineArgumentsNext.bind(this);
        this._handleAssignScriptNext = this._handleAssignScriptNext.bind(this);
        this._handleAssignScriptBack = this._handleAssignScriptBack.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { history } = this.props;
        if (prevProps.isSaving && !this.props.isSaving) {
            history.replace(`/${history.location.search}`)
        }
    }

    _handleDefineArgumentsNext (blockArgs, blockDom) {
        this.setState({ blockArgs, blockDom });
        this._incrementStep();
    }

    _handleAssignScriptNext (blockScript) {
        this.setState({ blockScript });
        const { blockInfo, blockDom: xml } = this.state;

        const xml_text = Blockly.Xml.domToText(blockToXmlSanitized(xml));
        let libraryId = this._findLibraryId(blockInfo.library);

        try {
            Parser.parse(blockScript, {})

            const blockPayload = {
                userId: this.props.userId,
                name: blockInfo.name,
                xml: xml_text,
                code: blockScript,
                language: 'javascript',
                version: '1.0.0',
                type: 'custom_js',
                keywords: blockInfo.keywords ? blockInfo.keywords.toString() : " ",
                libraryId: libraryId,
                description: blockInfo.description ?  blockInfo.description.toString() : " "
            };
            addTenantToPayload(blockPayload, this.props.tenantId, this.props.snapTenantGuid);
            this.props.saveBlock(blockPayload);

            this.props.history.push(`/${globalThis.location.search}`);
        } catch {
            this.setState({toastVisible: true});
        }
    }

    _handleAssignScriptBack (blockScript) {
        this.setState({blockScript});
        this._decrementStep();
    }

    render() {
        if (!this.props.block) { return null; }
        const { blockInfo, blockArgs, step, blockScript } = this.state;
        const { isSaving } = this.props;

        return (
            <div id={"save-modal-container"}>
                {
                    step === 1 && <NameBlock
                        values={blockInfo}
                        handleCancel={() => {}}
                        handleNext={this._handleNameBlockNext}
                        libraries={this.props.libraries}
                        JSFlag={"Custom Script"}
                        title={"Create Custom JS Code Block"}/>
                }
                {
                    step === 2 && <DefineArguments
                        values={blockArgs}
                        blockName={blockInfo.name}
                        type={"custom_js_block"}
                        handleBack={this._decrementStep}
                        handleCancel={() => {}}
                        handleNext={this._handleDefineArgumentsNext}
                        description={this.state.blockInfo.description ? this.state.blockInfo.description : ""}
                        JSFlag={"Custom Script"}
                        title={"Create Custom JS Code Block"}/>
                }
                {
                    step === 3 && <AssignScript
                        values={blockScript}
                        args={blockArgs}
                        isSaving={isSaving}
                        handleBack={this._handleAssignScriptBack}
                        handleCancel={() => {}}
                        handleNext={this._handleAssignScriptNext} />
                }
                {
                    this.state.toastVisible ?
                        <div className={"bootstrap-override"}>
                            <Toast onClose={() => {this.setState({toastVisible: false})}}
                                style={{position: 'absolute', margin: '0 auto', bottom: '50px'}}>
                                <Toast.Header>
                                    <strong className="me-auto">Script Error</strong>
                                </Toast.Header>
                                <Toast.Body>Please ensure that your code contains no syntax errors before saving.</Toast.Body>
                            </Toast>
                        </div>
                        : null
                }
            </div>
        );
    }
}

CreateJSBlock.propTypes = {
    sendValidatedToParent: PropTypes.func,
    userId: PropTypes.string,
    tenantId: PropTypes.string,
    snapTenantGuid: PropTypes.string,
    saveLibrary: PropTypes.func,
    libraries: PropTypes.array,
    isSaving: PropTypes.bool,
    saveBlock: PropTypes.func,
    block: PropTypes.object,
    history: PropTypes.object
};

export default withRouter(CreateJSBlock);
